import axios from 'axios';

export default function setAuthorizationToken(token: string | null): void {
    if (token) {
        axios.defaults.headers.common['Authorization'] = "bearer " + token;
    } else {
        axios.defaults.headers.common['Authorization'] = "";
    }

}